import { translateGroupChildren } from '../../items/group/translate-group-children';
import { EditorStarterItem } from '../../items/item-type';
import { EditorState } from '../types';

export const changeItem = (
  state: EditorState,
  itemId: string,
  updater: (item: EditorStarterItem) => EditorStarterItem,
): EditorState => {
  const existingItem = state.undoableState.items[itemId];

  if (!existingItem) return state;

  const updatedItem = updater(existingItem);
  if (updatedItem === existingItem) return state;

  // 갱신 아이템 반영 + 그룹 이동이면 children 에 delta 전파(그룹 bbox 는 SoT 가 아님).
  const items = translateGroupChildren(
    {
      ...state.undoableState.items,
      [itemId]: updatedItem,
    },
    existingItem,
    updatedItem,
  );

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      items,
    },
  };
};
